export default __webpack_public_path__ + "images/e0ba0fd6e83becafa5e768a915502a98-comet.svg";